module.exports = __webpack_public_path__ + "assets/shachen.55ffb00e.svg";